<div class="contract-row-card card-wrapper">
    <div class="card">
        @if (appFacadeService.isInvoiceSelectableAndAvailable(invoice.Id) | async) {
        <div class="head-top">
            <div class="checkbox">
                <por-base-checkbox
                    #check
                    [isChecked]="(appFacadeService.isInvoiceAvailableInState(invoice.Id) | async) || params.value"
                    (checkboxChange)="onCheckboxChange($event)"></por-base-checkbox>
            </div>
        </div>
        } @else {
        <div class="head-top">&nbsp;</div>
        }
        <ul>
            @for (item of invoiceKV; track item) {
            <li class="row">
                <div class="col-2">
                    <h5 class="title">{{ item.label | translate }}</h5>
                </div>
                <span>:</span>
                <div class="col-10">
                    @if (item.label === 'invoiceNumber') { @if (dueStatus === 'overdue') {
                    <mat-icon class="overdue-icon" [title]="'InvoiceOverdueLabel' | translate" [attr.aria-label]="'InvoiceOverdueLabel' | translate">error</mat-icon>
                    } @else if (dueStatus === 'dueSoon') {
                    <mat-icon class="due-soon-icon" [title]="'InvoiceDueSoonLabel' | translate" [attr.aria-label]="'InvoiceDueSoonLabel' | translate">schedule</mat-icon>
                    } } @if (item?.clickable) {
                    <data>
                        <span (click)="loadContractDetail()">{{ item?.value }}</span>
                    </data>
                    } @else {
                    <data>{{ item?.value }}</data>
                    }
                </div>
            </li>
            }
        </ul>
        <por-base-button (onclick)="viewInvoicePdf()" [featureName]="'view-detail-invoice'">{{ 'View PDF' | translate }}</por-base-button>
    </div>
</div>
